// Direct charges to an existing customer (for example a government fee or a
// handling fee on the saved card) are disabled on purpose, company wide, to avoid
// surprise second charges. Payment links stay available because the customer pays
// them on their own.
//
// Shared contract with etaapi: a blocked charge answers HTTP 403 with
// { code: "SECOND_CHARGES_DISABLED", message: SECOND_CHARGES_DISABLED_MESSAGE }.

export const SECOND_CHARGES_DISABLED_CODE = "SECOND_CHARGES_DISABLED";

export const SECOND_CHARGES_DISABLED_TITLE = "Charge blocked on purpose";

export const SECOND_CHARGES_DISABLED_MESSAGE =
  "Additional charges to a customer are disabled on purpose to prevent second charges. Contact an admin if a charge is truly needed.";

export const isSecondChargesDisabledError = (error) =>
  error?.response?.status === 403 &&
  error.response.data?.code === SECOND_CHARGES_DISABLED_CODE;
